// extracted by mini-css-extract-plugin
export default {"root":"LLPAManagementPage_root__oo3XT"};